module.exports = __webpack_public_path__ + "static/media/letters.fe0e3d0d.png";